export const BASE_URL = "https://lush-admin-f84ff6827e4b.herokuapp.com";
// export const BASE_URL = "http://localhost:5001";
export const GOOGLE_API_KEY = "AIzaSyD9WZya-ZOBv_nURKbzznQtWEG7tAIF0EE";
